<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局基础样式 */
* { margin: 0; padding: 0; box-sizing: border-box; }

html, body, #app {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  background: #f0f2f5;
  color: #303133;
}

/* 统一页面容器卡片 */
.page-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
}

/* 统一工具条 */
.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.toolbar .el-input,
.toolbar .el-select {
  width: 180px;
}

.toolbar-spacer { flex: 1; }

/* 统一表格容器 */
.table-wrap { margin-top: 4px; }

/* 分页统一右对齐 */
.pagination-right {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* 页面头部说明 */
.page-tip {
  color: #909399;
  font-size: 13px;
  margin-bottom: 12px;
}

/* Element 表格微调，让表格更清爽 */
.el-table th.el-table__cell {
  background-color: #fafafa !important;
  color: #606266;
  font-weight: 600;
}
.el-table .el-table__cell {
  padding: 10px 0;
}
</style>
